module.exports = __webpack_public_path__ + "static/media/DSC09875.c9a4b227.jpg";